
//FAQ
//Check if there is any Faq
if (document.querySelector('.o-simple-faq__inner')) {
  const questionsWraps = document.querySelectorAll('.o-simple-faq__inner');
  questionsWraps.forEach(questionGroup => activeGroupListener(questionGroup));
}
function activeGroupListener(questionGroup) {
  const questionTitles = document.querySelectorAll('.o-simple-faq__question');
  questionTitles.forEach(title => title.addEventListener('click', function () { title.classList.toggle("show"); }));
}